import { graphql } from 'react-relay';

export const performanceOverviewNumbersFragment = graphql`
    fragment PerformanceOverviewNumbers_data on PerformanceOverviewInfo {
        currentperformancetext
        currentbenchmarktext
        paperformancetext
        pabenchmarktext
    }
`;
